import React from 'react'
import { connect } from 'react-redux'
import Mousetrap from 'mousetrap'

import { shareNoteToEmail } from 'data/notes/actions'
import { MailIcon } from 'components/Utils/Icons'
import { Input, Button } from 'components/base'
import { Textarea } from 'components/Utils/Form'
import {
  filterEmails,
  convertTextToEmails,
} from 'components/Invitations/SendInvitationsForm/utils'

const ENTER_KEY_CODE = 13

class EmailForm extends React.Component {
  state = {
    emails: '',
    message: '',
  }

  componentDidMount() {
    this.mousetrap = new Mousetrap()
    this.mousetrap.bind(['command+enter'], () => {
      this.sendEmail()
    })
  }

  componentWillUnmount() {
    this.mousetrap.reset()
  }

  sendEmail = () => {
    const { shareNoteToEmail, closePopover } = this.props
    const formattedEmails = filterEmails(convertTextToEmails(this.state.emails))
    shareNoteToEmail({
      input: {
        noteId: this.props.note.id,
        emails: formattedEmails,
        message: this.state.message,
      },
    })
    closePopover()
  }

  onKeyDown = e => {
    if (e.keyCode === ENTER_KEY_CODE && e.metaKey) {
      // Command + Enter
      this.sendEmail()
    }
  }

  render() {
    const { toggleOffEmailForm } = this.props
    return (
      <div>
        <div className="flexbox flexbox-align-center border-bottom-small border-shade-50 padding-horizontal-large ">
          <MailIcon size={12} className="shade-30" />
          <div className="width-full">
            <Input
              name="emails"
              value={this.state.emails}
              onChange={event => this.setState({ emails: event.target.value })}
              placeholder="A list of comma separated emails"
              className="border-none font-size-large"
              onKeyDown={this.onKeyDown}
              autoFocus
            />
          </div>
          <div
            className="shade-20 shade-10-on-hover pointer font-size-large font-weight-medium border-left-small border-shade-40 padding-left-medium"
            onClick={event => {
              event.preventDefault()
              event.stopPropagation()
              toggleOffEmailForm()
            }}
          >
            Back
          </div>
        </div>
        <Textarea
          onChange={event => this.setState({ message: event.target.value })}
          placeholder="Add a message"
          value={this.state.message}
          className="border-none placeholder-shade-30 font-size-large background-transparent shade-05"
          resize="none"
          height={150}
          onKeyDown={this.onKeyDown}
        />
        <div className="flexbox flexbox-justify-end background-shade-50 padding-vertical-medium padding-horizontal-large">
          <Button.Primary
            onClick={this.sendEmail}
            disabled={!this.state.emails}
          >
            <div className="flexbox flexbox-align-center">
              <MailIcon size={12} />
              <div className="margin-left-normal">Send</div>
            </div>
          </Button.Primary>
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  { shareNoteToEmail }
)(EmailForm)
